<template>
  <section class="px-4 py-12 md:py-16">
    <div class="max-w-3xl mx-auto w-full">
      <div class="p-6 rounded-2xl border border-neutral-500 flex flex-col md:flex-row gap-4">
        <VaIcon name="info" color="primary" size="28px" class="flex-shrink-0" />
        <div class="flex flex-col gap-2">
          <h3 class="mt-0 mb-0">{{ t('landing.suisa.title') }}</h3>
          <p class="text-neutral-300 mt-0 mb-0">{{ t('landing.suisa.text') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { VaIcon } from 'vuestic-ui'

const { t } = useI18n()
</script>
